export default {
  ROUNDED: 'rounded',
  FLAT: 'flat',
};
